import type { APIDefinition } from '@/core/lib/fetch/fetch';
import { api, APIError, ApiMethods, ApiVersions, destroy, ErrorKind, get, image, patch, post, put } from '@/core/lib/fetch/fetch';

export type { APIDefinition };
export { api, APIError, ApiMethods, ApiVersions, destroy, ErrorKind, get, image, patch, post, put };
